import React from "react";

const SuspendedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md text-center shadow-lg">
        <span className="text-4xl mb-4 block">🚫 Suspended</span>
        <h2 className="text-xl font-bold mb-2">Your account has been suspended</h2>
        <p className="text-gray-700 mb-2">
          Your account has been suspended for violating our community rules.
        </p>
        <p className="text-gray-700 mb-4">
          Please contact{" "}
          <a
            href="mailto:support@investorlanes.com"
            className="text-blue-600 hover:underline"
          >
            support@investorlanes.com
          </a>{" "}
          if you believe this is a mistake.
        </p>
        <button
          onClick={onClose}
          className="mt-2 px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SuspendedModal;
